import { render, staticRenderFns } from "./PlayerMixcloud.vue?vue&type=template&id=3ade24ad&scoped=true&"
import script from "./PlayerMixcloud.vue?vue&type=script&lang=js&"
export * from "./PlayerMixcloud.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMixcloud.vue?vue&type=style&index=0&id=3ade24ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade24ad",
  null
  
)

export default component.exports